import React, { useState, useEffect, useRef, useMemo, use } from "react";
import { Box, Typography, IconButton, Dialog } from "@mui/material";
import { LuPlus, LuArrowLeft } from "@/Components/Icons/Icons";
import { BlackButton } from "@/Components/Buttons/FiledButton";
import { navurl } from "@/Config/Routeconfig/NavigationUrl";
import { OutLinedButton } from "@/Components/Buttons/OutLinedButton";
import { Menu, MenuItem } from "@mui/material";
import { getAllNamesFromMultipleSchemas } from "@/Utils/CsvColumns";
import { useNavigate, useParams } from "react-router-dom";
import { useUser } from "@/Context/UserContext";
import { SectionHeader } from "@/Components/Header/SectionsHeader";
import { OrganizationHookMap } from "../../../redux/OrganizationhookMap";
import { BiSolidError } from "react-icons/bi";
import { iconMap } from "@/redux/iconMap";
import { TabWithIndependentButtons } from "@/Components/Tabs/SubTabs";
import { useLazyGetGeneralAddressByMasterIdQuery } from "../../../redux/Organization/CreateNewCustomer/General";
import { useCustomer } from "../../../Context/CustomerContext";
import FormGenerator from "@/Utils/FormGenerator/FormGenerator";
import SuccessDialog from "@/Components/Dialog/SuccessDialog";
import CreateNewJobSidebarItems from "../../../Config/Export/CreateNewCustomer/CreateNewCustomersidebar";
import TableGenerator from "@/Utils/FormGenerator/TableGenerator";
import CustomTabs from "@/Components/Tabs/CustomTab";
import TableWithFieldGenerator from "@/Utils/FormGenerator/TableWithFieldGenerator";
import FormDialog from "@/Components/Dialog/FormDialog";
import CheckboxBox from "@/Components/Form/CheckboxBox";
import dayjs from "dayjs";
import Papa from "papaparse";
import CreateJobLayout from "../../../Views/ExportJob/CreateNewCustomer/CreateNewCustomerLayout";
import schema1 from "../../../Config/Export/CreateNewCustomer/GeneralAddress";
import schema2 from "../../../Config/Export/CreateNewCustomer/MoreAddress";
import { dynamicComponentMap } from "@/Utils/DynamicComponents";
import { LuCheck } from "react-icons/lu";
import { applyDynamicRules } from "@/Utils/Rules/ApplyConditions";
import { tabToEximCodeMap } from "@/Constant/Common/Common";
import { defaultValues } from "@/Constant/Common/Common";
import { useLazyGetDocumentByTemplateQuery } from "../../../redux/ExportPage/CreateNewJob/Documents";
import CreateFilterBox from "../../../Views/ExportJob/CreateNewCustomer/CreateNewCustomerFilter";
import RenameSchemaFields from "@/Utils/RenameSchemaFields";
// import { mapSingleRegType } from "../../../redux/mappers/Customer/regMapper";
import { mapKycDocument } from "../../../redux/mappers/Customer/DocumentMapper";

const CreateNewJob = () => {
  const formRef = useRef();
  const [activeIndex, setActiveIndex] = useState(0);
  const [activeSubIndex, setActiveSubIndex] = useState(0);
  const [activeNestedIndex, setActiveNestedIndex] = useState(0);
  const [isEditing, setIsEditing] = useState(false);
  const [triggerGetDocument] = useLazyGetDocumentByTemplateQuery();
  const clearAll = useUser((s) => s.clearAll);
  const isRequiredFieldFilled = useUser((s) => s.isRequiredFieldFilled);
  const setIsRequiredFieldFilled = useUser((s) => s.setIsRequiredFieldFilled);
  const loading = useUser((s) => s.loading);
  const setLoading = useUser((s) => s.setLoading);
  const formData = useUser((s) => s.formData);
  const setFormData = useUser((s) => s.setFormData);
  const setIsDataFetched = useUser((s) => s.setIsDataFetched);
  const exporterCustomerid = useUser((s) => s.exporterCustomerid);
  const setExporterCustomerid = useUser((s) => s.setExporterCustomerid);
  const setFilterTrigger = useUser((s) => s.setFilterTrigger);
  const [showAdvancedFilters, setShowAdvancedFilters] = useState(false);
  const [successDialogConfig, setSuccessDialogConfig] = useState(null);
  const [showSuccessDialog, setShowSuccessDialog] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [subDialogConfig, setSubDialogConfig] = useState(false);
  const [subDialogOpen, setSubDialogOpen] = useState(false);

  const [formDialogData, setFormDialogData] = useState({});
  const [schema, setSchema] = useState({});
  const [saveLoading, setSaveLoading] = useState(false);
  const [dialogOwnerConfig, setDialogOwnerConfig] = useState(null);
  const { customerId } = useParams();
  const [disableCopy, setDisableCopy] = useState(false);
  const [sidebarItems, setSidebarItems] = useState([]);
  const [openComponent, setOpenComponent] = useState(null);
  const [trigger, setTrigger] = useState(0);
  const [processingId, setProcessingId] = useState(null);
  const [extraApi, setExtraApi] = useState(null);
  const [tablecompKey, setTableCompkey] = useState(null);
  const [subTabs, setSubTabs] = useState();
  const currentTabType = useUser((s) => s.currentTabType);
  const [blocks, setBlocks] = useState([{ id: Date.now() }]);

  useEffect(() => {
    clearAll();
  }, []);

  useEffect(() => {
    setExporterCustomerid(customerId);
  }, [customerId]);

  // ✅ Get initial items from hook
  // Generate the static initial sidebar
  const initialItems = useMemo(
    () => CreateNewJobSidebarItems(formData),
    [formData]
  );

  // 1️⃣ Flatten all APIs from nested sidebar items
  const collectApiKeys = (items) => {
    let keys = [];
    items.forEach((item) => {
      if (item.api) keys.push(item.api);
      if (item.tableApi) keys.push(item.tableApi);
      if (item.extraApi) keys.push(item.extraApi);
      if (item.subTabs) keys.push(...collectApiKeys(item.subTabs));
    });
    return keys;
  };

  // 2️⃣ Custom hook to call all API hooks safely
  const useSidebarApiHooks = (items) => {
    const allKeys = Array.from(new Set(collectApiKeys(items))); // unique
    const results = allKeys.map((key) => {
      const hook = OrganizationHookMap[key];
      return hook ? hook() : null; // ✅ called unconditionally
    });
    return allKeys.reduce((acc, key, i) => {
      acc[key] = results[i];
      return acc;
    }, {});
  };

  const apiHooks = useSidebarApiHooks(initialItems);

  // Update sidebar items dynamically when formData changes
  useEffect(() => {
    const updatedItems = applyDynamicRules(initialItems, formData);
    setSidebarItems(updatedItems);

    const currentItem = updatedItems[activeIndex];
    if (currentItem?.disabled) {
      const firstEnabledIndex = updatedItems.findIndex(
        (item) => !item.disabled
      );
      if (firstEnabledIndex !== -1) setActiveIndex(firstEnabledIndex);
    }
  }, [formData]);

  const openForm = (
    schema,
    label,
    ownerConfig = null,
    extraApi = null,
    compkey = null
  ) => {
    setFormDialogData({});
    setIsEditing(false);
    setShowForm(true);
    setExtraApi(extraApi);
    setSchema({ schema, label });
    // setTableCompkey(compkey);
    if (ownerConfig) {
      setDialogOwnerConfig(ownerConfig);
    }
  };
  console.log("Form Data in CNewJob:", formData);
  const renameInitialDataKeys = (data, index) => {
    const renamed = {};

    Object.entries(data).forEach(([key, value]) => {
      renamed[`${key}_${index}`] = value; // others = append _1, _2...
    });
    return renamed;
  };

  const DynamicSchemaWrapper = React.forwardRef(
    (
      {
        baseSchema,
        initialArrayData = [],
        formKey,
        onSubmit = () => {},
        ...otherProps
      },
      ref
    ) => {
      console.log(initialArrayData, "initialArrayData");

      const [blocks, setBlocks] = useState(() => {
        if (Array.isArray(initialArrayData) && initialArrayData.length > 0) {
          return initialArrayData.map((item, index) => ({
            id: Date.now() + index,
            schema: RenameSchemaFields(baseSchema, index),
            initialData: renameInitialDataKeys(item, index),
            signatoryId: item.signatoryId,
          }));
        }

        return [{ id: Date.now(), schema: baseSchema, initialData: {} }];
      });

      const formRefs = useRef([]);

      const handleAction = async (action) => {
        if (action.action === "addSchema") {
          setBlocks((prev) => {
            const newIndex = prev.length;
            const newSchema = RenameSchemaFields(baseSchema, newIndex);
            return [
              ...prev,
              {
                id: Date.now(),
                schema: newSchema,
                index: newIndex,
                initialData: renameInitialDataKeys({}, newIndex),
                [`signatoryId_${newIndex}`]: null,
              },
            ];
          });
        } else if (action.action === "removeSchema") {
          const key = action.data.name;
          let matchedBlock = blocks.find(
            (block) =>
              block.initialData && block.initialData.hasOwnProperty(key)
          );

          if (!matchedBlock) {
            matchedBlock = blocks.find((block) =>
              Object.prototype.hasOwnProperty.call(block, key)
            );
          }

          setBlocks((prev) => prev.filter((b) => b.id !== matchedBlock?.id));

          console.log("Matched Block:", matchedBlock, action.data);
          await handleDelete(matchedBlock.signatoryId);
        }
      };

      React.useImperativeHandle(ref, () => ({
        submit: async () => {
          const allBlocks = [];

          for (const child of formRefs.current) {
            if (child?.submit) {
              const result = await child.submit();
              allBlocks.push(result);
            }
          }

          if (otherProps.forceArray) {
            return allBlocks;
          }

          if (allBlocks.length === 1) {
            return allBlocks[0];
          }

          return allBlocks;
        },

        reset: () => {
          formRefs.current.forEach((child) => child?.reset?.());
        },
      }));

      return (
        <>
          {blocks.map((block, index) => (
            <React.Fragment key={block.id}>
              <FormGenerator
                // compKey={formKey}
                schema={block.schema}
                isLastBlock={index === blocks.length - 1}
                compKey={`${formKey}_${block.id}`}
                key={`${formKey}_${block.id}`}
                initialData={block.initialData} // REQUIRED
                ref={(el) => (formRefs.current[index] = el)}
                onSubmit={handleAction}
                showRemove={blocks.length > 1}
                {...otherProps}
              />
              {index < blocks.length - 1 && (
                <hr
                  style={{
                    margin: "20px 0",
                    borderTop: "2px dashed rgb(0, 0, 0)",
                  }}
                />
              )}
            </React.Fragment>
          ))}
        </>
      );
    }
  );

  const jsonSchemaColumns = getAllNamesFromMultipleSchemas([schema1, schema2]);

  const navigate = useNavigate();

  const fileInputRef = useRef();

  const handleImportClick = () => {
    // localStorage.removeItem("exporterCustomerid");
    navigate("/export/job", { replace: true });
    setTimeout(() => {
      fileInputRef.current.click();
    }, 100);
  };

  const handleFileSelect = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    Papa.parse(file, {
      header: true,
      skipEmptyLines: true,
      complete: (results) => {
        const csvData = results.data;

        // Base object with all schema columns empty
        const baseObject = {};
        jsonSchemaColumns.forEach((col) => {
          baseObject[col] = "";
        });

        // Merge CSV row values into base object
        const mappedData = csvData.map((row) => {
          const newRow = { ...baseObject };
          jsonSchemaColumns.forEach((col) => {
            if (row[col] !== undefined) newRow[col] = row[col];
          });
          return newRow;
        });

        // Form ku first row
        const finalData = mappedData[0] || baseObject;
        setFormData(finalData);

        // Table ku all rows + index
        const tableWithIndex = mappedData.map((row, idx) => ({
          id: idx + 1,
          ...row,
        }));
        setTableData(tableWithIndex);
      },
      error: (err) => console.error("CSV parse error:", err),
    });
  };

  const goToCreateNewJob = async () => {
    try {
      // Step 1: Show loader
      setLoading(true);
      // Step 2: Clear data
      await new Promise((resolve) => {
        clearAll({});
        setTimeout(resolve, 800); // small delay to let context clear
      });

      // Step 3: Set states
      setIsDataFetched(true);
      setDisableCopy(true);

      // Step 4: Navigate
      navigate("/export/job");
    } catch (err) {
      console.error("Error while creating new job:", err);
    } finally {
      // Step 5: Hide loader
      setLoading(false);
    }
  };

  const copyJobData = () => {
    navigate("/export/job");
  };

  const handleCloseForm = () => {
    setIsEditing(false);
    setFormDialogData({});
    setShowForm(false);
    setSubDialogOpen(false);
    setDialogOwnerConfig(null);
  };

  const handlers = {
    handleEdit: (row) => {
      if (!row) return;
      setFormDialogData(row);
      setIsEditing(true);
      setShowForm(true);
      setSchema(currentTab.schema);
    },
    handleRemove: async (row) => {
      try {
        console.log("Attempting to delete row:", row);
        await handleDelete({ id: row.id });
      } catch (err) {
        console.error("Failed to delete:", err);
      }
    },
    handleRowClick: async (row) => {
      try {
        await handleRowSelect({ id: row.id });
      } catch (err) {
        console.error("Failed to select the row:", err);
      }
    },
    handleView: (row) => {
      if (!row) return;
      const fileObjectKey = Object.keys(row).find(
        (key) =>
          row[key] &&
          typeof row[key] === "object" &&
          row[key].filePath &&
          row[key].fileName
      );

      if (fileObjectKey) {
        const fileData = row[fileObjectKey];
        try {
          const fileUrl = `${import.meta.env.VITE_BASE_FILE_URL}${fileData.filePath}`;
          window.open(encodeURI(fileUrl), "_blank");
        } catch (err) {
          console.error("View failed:", err);
        }
        return;
      }
    },
  };

  const [fetchExportGeneral, { data, isFetching }] =
    useLazyGetGeneralAddressByMasterIdQuery();

  const handlerefresh = async (id = exporterCustomerid) => {
    // 🟢 Log raw ID received

    // 🟢 FIX: If id is an object → extract the real id
    const cleanId = typeof id === "object" ? id?.id : id;

    try {
      setLoading(true);

      const result = await fetchExportGeneral({
        id: cleanId.id,
      }).unwrap();

      if (!result) {
        console.warn("⚠️ No result returned from API");
        return;
      }

      setFormData((prev) => ({
        ...prev,
        ["customer"]: {
          ...(prev["customer"] || {}),
          ...result,
        },
      }));

      setIsRequiredFieldFilled(true);
    } catch (err) {
      console.error("❌ Error fetching data:", err);
    } finally {
      setSaveLoading(false);
      setIsDataFetched(true);
    }
  };

  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedDoc, setSelectedDoc] = useState("");
  const [anchorEl1, setAnchorEl1] = useState(null);

  const { addressId } = useCustomer();
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setAnchorEl1(null);
  };

  const functionMap = {
    handleOpen: (event, btn) => {
      const button = event.target.closest("button");
      setAnchorEl1(button);

      // If the JSON specifies a component to open, store it
      if (btn.component) {
        setOpenComponent(btn);
      }
    },

    handleClose: () => {
      setAnchorEl1(null);
      setOpenComponent(null);
    },
  };

  // const sidebarItems = CreateNewJobSidebarItems(formData);
  const activeItem = sidebarItems[activeIndex] ?? {};
  const activeSubTab =
    activeItem?.type === "tab"
      ? activeItem.subTabs?.find((subTab) => subTab.id === activeSubIndex) ||
        activeItem.subTabs[activeSubIndex]
      : null;

  const activeNestedTab =
    activeSubTab?.type === "tab"
      ? activeSubTab.subTabs[activeNestedIndex]
      : null;

  const currentTab = activeNestedTab || activeSubTab || activeItem;

  useEffect(() => {
    setActiveSubIndex(0);
    setActiveNestedIndex(0);
  }, [activeIndex, addressId]);

  useEffect(() => {
    setActiveNestedIndex(0);
  }, [activeSubIndex]);

  const handleSelect = async (doc) => {
    setSelectedDoc(doc);
    handleClose();

    const customerId = formData?.customer?.customerId;

    try {
      const response = await triggerGetDocument({
        templatetype: doc, // e.g. "CheckList"
        jobid: customerId, // rename correctly if it's actually jobid
      }).unwrap();
      //  🔥 Handle PDF binary data properly
      const blob = new Blob([response], { type: "application/pdf" });
      const url = URL.createObjectURL(blob);
      window.open(url, "_blank"); // open PDF in new tab
    } catch (error) {
      console.error("Error generating PDF:", error);
    }
  };

  useEffect(() => {
    if (formData?.general?.processingId) {
      setProcessingId(formData?.general?.processingId);
    }
  }, [formData]);

  // ==========================
  useEffect(() => {
    let isMounted = true;

    const fetchTabData = async () => {
      const isTriggerRefresh = typeof trigger === "number" && trigger > 0;
      const sidebarItems = CreateNewJobSidebarItems();

      const activeItem = sidebarItems[activeIndex];
      const activeSubTab =
        activeItem?.type === "tab"
          ? activeItem.subTabs?.find(
              (subTab) => subTab.id === activeSubIndex
            ) || activeItem.subTabs[activeSubIndex]
          : null;

      const activeNestedTab =
        activeSubTab?.type === "tab"
          ? activeSubTab.subTabs[activeNestedIndex]
          : null;

      const config = activeNestedTab || activeSubTab || activeItem;

      try {
        if (!isTriggerRefresh) {
          setIsDataFetched(false);
          setLoading(true);
        }

        setIsRequiredFieldFilled(false);

        if (!config?.api && !config?.tableApi) {
          console.warn("⚠️ No API found for this tab");
          return;
        }

        const { fetch } = apiHooks[config.api] || {};
        const { fetchTable } = apiHooks[config.tableApi] || {};
        const { fetchExtraApi } = apiHooks[config.extraApi] || {};

        if (!fetch && !fetchTable) {
          console.warn("⚠️ No fetch method in hooks =>", config?.label);
          return;
        }

        /** -------------------------------
         * 🆔 Resolve Master ID
         * ------------------------------*/
        let id =
          config.id === "customer"
            ? addressId
            : exporterCustomerid || customerId;

        // replaceMasterId
        if (config.replaceMasterId) {
          const data = formData[config.replaceMasterId];

          if (Array.isArray(data) && data.length > 0) {
            const selectedItem = data.find((item) => item.selected);
            id = selectedItem ? selectedItem.id : data[0].id;
          } else if (data && typeof data === "object") {
            id = data.id;
          }
        }
        console.log("handleSave(): Initial Config =", config?.id);

        /** -------------------------------
         * 📌 subId (attachData) handling
         * ------------------------------*/
        let dataId = null;

        if (config.attachData) {
          const dataArray = formData[config.attachData] || [];

          dataId =
            dataArray.find((item) => item.selected)?.id || dataArray[0]?.id;
        }

        const payload = { id };
        if (dataId) payload.subId = dataId;

        const response = await fetch(payload);
        let extraResponse;

        if (config.extraApi) {
          extraResponse = await fetchExtraApi(payload);
          console.log("extraResponse:", extraResponse);
            const extraTargetKey = `${config.extraApi}`;

            setFormData((prev) => ({
              ...prev,
              [extraTargetKey]: {
                ...(prev[extraTargetKey] || {}),
                ...extraResponse,
              },
            }));
        }

        if (!["table", "tableWithFields"].includes(config.type)) {
          setFormData((prev) => ({
            ...prev,
            [config.type == "formWithTable" ? config.id + "Form" : config.id]: {
              ...(prev[
                config.type == "formWithTable" ? config.id + "Form" : config.id
              ] || {}),
              ...response,
            },
          }));
        }

        let selectedItem = null;

        if (config.attachData && formData?.[config.attachData]) {
          const attachArr = Array.isArray(formData[config.attachData])
            ? formData[config.attachData]
            : [formData[config.attachData]];

          selectedItem = attachArr.find((item) => item?.selected);
        } else {
          console.warn("⚠️ No attachData found OR formData missing");
        }

        let tableId;

        if (config.tableReplaceMasterId) {
          tableId =
            response?.[`${config.tableReplaceMasterId}Id`] ||
            formData[config.tableReplaceMasterId]?.id ||
            exporterCustomerid ||
            customerId;
        } else {
          tableId =
            selectedItem?.id ||
            response?.[`${config.tableReplaceMasterId}Id`] ||
            exporterCustomerid ||
            customerId;
        }

        let tableResponse = null;

        if (config.type === "table" || config.type === "tableWithFields") {
          if (config.tableApi) {
            tableResponse = await fetchTable({ id: tableId });
          }

          setFormData((prev) => {
            const oldRows = prev[config.id] || [];
            const previouslySelected = oldRows.find((x) => x.selected);

            const newRows = response?.map((row) => ({
              ...row,
              selected: previouslySelected
                ? row.id === previouslySelected.id
                : false,
            }));

            return {
              ...prev,
              [config.id]: newRows,
            };
          });
        }
      } catch (err) {
        console.error("%c❌ ERROR in fetchTabData:", "color:red", err);
      } finally {
        if (isMounted) {
          setLoading(false);
          setIsDataFetched(true);
        }
      }
    };

    fetchTabData();

    return () => {
      isMounted = false;
    };
  }, [activeIndex, activeSubIndex, activeNestedIndex, addressId, trigger]);

  const handleRowSelect = async (id, dataKey = currentTab.id) => {
    setFormData((prev) => ({
      ...prev,
      [dataKey]: (prev[dataKey] || []).map((row) => ({
        ...row,
        selected: row.id === (id.id || id), // mark only the selected row
      })),
    }));
  };

  const handleDelete = async (rawId) => {
    const normalizeId = (input) => {
      if (typeof input === "string" || typeof input === "number") {
        return currentTab.needsSubId
          ? { id: customerId, subId: input }
          : { id: input };
      }

      if (input && typeof input === "object") {
        if (input.id && typeof input.id === "object" && input.id.id) {
          return { id: String(input.id.id) };
        }
        if (
          input.id &&
          (typeof input.id === "string" || typeof input.id === "number")
        ) {
          return { id: String(input.id) };
        }

        const result = {};
        Object.entries(input).forEach(([k, v]) => {
          if (v !== undefined && v !== null) result[k] = String(v?.id ?? v);
        });
        if (Object.keys(result).length) return result;
      }

      return { id: undefined };
    };

    const normalized = normalizeId(rawId);

    // If we couldn't get any id, bail early with a log
    if (!normalized.id) {
      console.error(
        "❌ Unable to extract an 'id' from the provided parameter:",
        rawId
      );
      // show user-friendly dialog if necessary
      setSuccessDialogConfig({
        label: "Failure",
        subtitle: (
          <strong style={{ fontSize: "1rem", color: "var(--brand-900)" }}>
            Invalid id provided for delete
          </strong>
        ),
        buttonText: "OK",
        status: "error",
        icon: BiSolidError,
      });
      setShowSuccessDialog(true);
      return;
    }

    try {
      setLoading(true);

      if (!currentTab?.api) {
        console.warn("⚠️ No API configured for:", currentTab?.label);
        return;
      }

      console.log("📌 currentTab.id =", currentTab?.id);
      console.log("📌 currentTab.type =", currentTab?.type);

      const deleteProcess = currentTab?.tableApi
        ? (apiHooks[currentTab.tableApi] || {}).deleteTableFn
        : (apiHooks[currentTab.api] || {}).deleteFn;

      if (!deleteProcess) {
        console.error("❌ No delete function found!");
        return;
      }

      // decide payload shape: many of your hooks seem to accept { id } or { id, subId }
      const apiPayload = normalized;
      console.log("🚀 Calling delete API with payload:", apiPayload);

      const response = await deleteProcess(apiPayload).unwrap();
      console.log("✅ API DELETE RESPONSE =", response);

      // FORM case
      if (currentTab.type === "form") {
        console.log("🧾 Deleting FORM data…");
        setFormData((prev) => ({ ...prev, [currentTab.id]: {} }));
        formRef.current?.reset?.();
        setIsEditing(false);
        setSuccessDialogConfig({
          label: "Success",
          subtitle: (
            <strong style={{ fontSize: "1rem", color: "var(--brand-900)" }}>
              Form deleted successfully
            </strong>
          ),
          buttonText: "OK",
          IconComponent: LuCheck,
          status: "success",
        });
        setShowSuccessDialog(true);
        return response;
      }

      // TABLE case: remove row from state. Be defensive about incoming id shapes.
      setFormData((prev) => {
        const existingArray = prev[currentTab.id] || [];
        console.log("📦 existing rows before delete:", existingArray);

        // remove if row.id matches normalized.id OR row.id matches raw object's nested value
        const updatedArray = existingArray.filter((r) => {
          const rowId = r?.id ?? r; // handle if row is primitive or object
          // compare as strings
          if (String(rowId) === String(normalized.id)) return false;

          // also handle rows where id itself is an object: { id: '...' }
          if (rowId && typeof rowId === "object") {
            const nested = rowId.id ?? rowId;
            if (String(nested) === String(normalized.id)) return false;
          }

          return true;
        });

        console.log("🧹 updated rows after delete:", updatedArray);
        return { ...prev, [currentTab.id]: updatedArray };
      });

      // clear selection
      setFormData((prev) => ({
        ...prev,
        [currentTab.id]: (prev[currentTab.id] || []).map((row) => ({
          ...row,
          selected: false,
        })),
      }));

      setIsEditing(false);
      formRef.current?.reset?.();

      const ok =
        response?.data?.statusCode === 200 || response?.statusCode === 200;

      setSuccessDialogConfig({
        label: ok ? "Success" : "Failure",
        subtitle: (
          <strong style={{ fontSize: "1rem", color: "var(--brand-900)" }}>
            {ok ? "Data deleted successfully" : "Something went wrong"}
          </strong>
        ),
        buttonText: "OK",
        IconComponent: ok ? LuCheck : BiSolidError,
        status: ok ? "success" : "error",
      });
      setShowSuccessDialog(true);

      return response;
    } catch (err) {
      console.error("❌ ERROR in handleDelete:", err);
      setSuccessDialogConfig({
        label: "Failure",
        subtitle: (
          <strong style={{ fontSize: "1rem", color: "var(--brand-900)" }}>
            {err?.data?.message || "Something went wrong"}
          </strong>
        ),
        buttonText: "OK",
        status: "error",
        icon: BiSolidError,
      });
      setShowSuccessDialog(true);
      throw err;
    } finally {
      console.log("🏁 handleDelete() FINISHED");
      setLoading(false);
    }
  };

  const extraHandleSave = async (extraApi, updatedData, name) => {
    try {
      if (!extraApi) return;

      const apiSet = apiHooks[extraApi];
      if (!apiSet) {
        console.warn(`⚠️ No API found for ${extraApi}`);
        return;
      }

      const { fetch, create, update } = apiSet;

      let extraResponse;

      let id = customerId;

      const cleanData = Object.fromEntries(
        Object.entries(updatedData || {}).filter(
          ([_, v]) => v != null && v !== ""
        )
      );
      // GET process with query params
      if (fetch) {
        let data = new URLSearchParams(cleanData).toString();

        extraResponse = await fetch({
          id,
          data,
        });
      }

      // CREATE process
      else if (create) {
        extraResponse = await create({ id: customerId, ...cleanData }).unwrap();
      }
      // UPDATE process
      else if (update) {
        extraResponse = await update({ id: customerId, ...cleanData }).unwrap();
      }

      setShowForm(false);
      return extraResponse;
    } catch (err) {
      console.error(`❌ Extra API failed for ${extraApi}:`, err);
    }
  };

  const flattenDataTable = (obj) => {
    if (obj === null || obj === undefined) return obj;

    const isoRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/;

    // If obj is a string, check if it's an ISO date
    if (typeof obj === "string") {
      if (isoRegex.test(obj)) {
        const parsed = dayjs(obj);
        if (parsed.isValid()) return parsed.format("DD-MM-YYYY HH:mm:ss");
      }
      return obj;
    }

    // If obj is a number, boolean, or other primitive, return as is
    if (typeof obj !== "object") return obj;

    // If obj is an array, map recursively
    if (Array.isArray(obj)) {
      return obj.map((item) => flattenDataTable(item));
    }

    // Now obj is a plain object
    if ("name" in obj) return obj.name;
    if ("label" in obj) return obj.label;

    // Otherwise, recurse for nested objects
    return Object.fromEntries(
      Object.entries(obj).map(([key, value]) => {
        // If value is string and matches ISO, convert it
        if (typeof value === "string" && isoRegex.test(value)) {
          const parsed = dayjs(value);
          return [
            key,
            parsed.isValid() ? parsed.format("DD-MM-YYYY HH:mm:ss") : value,
          ];
        }

        // Otherwise, recurse
        return [key, flattenDataTable(value)];
      })
    );
  };

  useEffect(() => {}, [formData]);

  // import mapKycDocument near top:

  const handleSave = async (type) => {
    try {
      const filledData = formRef.current ? await formRef.current.submit() : {};
      console.log("Filled data:", filledData);
      if (!Object.keys(filledData || {}).length) {
        console.warn("No data from form");
        return;
      }

      // resolve config (active tab/subtab/nested)
      const resolveConfig = (items, id) => {
        for (const item of items) {
          if (item.id === id) return item;
          if (item.subTabs) {
            const found = resolveConfig(item.subTabs, id);
            if (found) return found;
          }
        }
        return null;
      };

      let config = activeNestedTab || activeSubTab || activeItem;
      if (dialogOwnerConfig) {
        config = resolveConfig(sidebarItems, dialogOwnerConfig) || config;
      }

      if (!config) {
        console.warn("No config found");
        return;
      }
      if (!config.api) {
        console.warn("Config has no API");
        return;
      }

      // special case: documents (KYC)
      let updatedData = {};
      if (config.id === "kycDocument") {
        updatedData = mapKycDocument(filledData, formData);
        console.log("KY C payload:", updatedData);
      } else {
        // normal transform (convert objects to id)
        if (Array.isArray(filledData)) {
          updatedData = filledData.map((item) =>
            Object.fromEntries(
              Object.entries(item).map(([k, v]) => [k, v?.id ?? v])
            )
          );
        } else {
          updatedData = Object.fromEntries(
            Object.entries(filledData).map(([k, v]) => [k, v?.id ?? v])
          );
        }
      }

      // customer id resolution
      let customerId = exporterCustomerid;
      if (config.replaceMasterId) {
        const data = formData[config.replaceMasterId];
        if (Array.isArray(data) && data.length > 0) {
          customerId = data.find((i) => i.selected)?.id || data[0].id;
        } else if (data && typeof data === "object") {
          customerId = data.id;
        }
      }
      console.log(
        config?.extraApi && type !== "table" ? config.extraApi : config.api,
        "extra api available or not check"
      );
      const apiSet =
        apiHooks[
          config?.extraApi && type !== "table" ? config.extraApi : config.api
        ] || {};
      const { create, update } = apiSet;
      let response;

      if (filledData.selectedId && update) {
        response = await update({
          subId: filledData.selectedId,
          id: customerId,
          ...updatedData,
        }).unwrap();
      } else if (create) {
        response = await create({ id: customerId, ...updatedData }).unwrap();
      }

      // reset form and show success
      await formRef.current?.reset?.();

      const ok =
        response?.success === true ||
        response?.data?.success === true ||
        response?.data?.statusCode === 200 ||
        response?.statusCode === 200;

      setSuccessDialogConfig({
        label: ok ? "Success" : "Failure",
        subtitle: (
          <strong style={{ fontSize: "1rem", color: "var(--brand-900)" }}>
            {response?.data?.message ||
              response?.message ||
              "Data saved successfully"}
          </strong>
        ),
        buttonText: "OK",
        IconComponent: ok ? LuCheck : BiSolidError,
        status: ok ? "success" : "error",
      });
      setShowSuccessDialog(true);
      return { response };
    } catch (err) {
      console.error("Save error:", err);
      throw err;
    } finally {
      setLoading(false);
      setSaveLoading(false);
      setTrigger((p) => p + 1);
      setIsEditing(false); // Reset editing state
    }
  };

  const renderButtons = (
    subButtons = [],
    subcheckBox = [],
    schema,
    label,
    type
  ) => {
    if (!subButtons.length && !subcheckBox.length) return null;

    return (
      <Box
        display="flex"
        justifyContent={subcheckBox.length > 0 ? "space-between" : "flex-end"}
        alignItems="center"
        mb={2}
      >
        {subcheckBox.length > 0 && (
          <Box display="flex" flexWrap="wrap" gap={1} px={3}>
            {subcheckBox.map((item, idx) => (
              <CheckboxBox
                key={idx}
                checkboxLabel={item.label}
                value={[item.label] || false}
                onChange={(val) => handleCheckboxChange(item.label, val)}
              />
            ))}
          </Box>
        )}

        {subButtons.length > 0 && (
          <Box display="flex" gap={1}>
            {subButtons.map((btn, idx) => {
              const Icon = iconMap[btn.icon];
              return (
                <OutLinedButton
                  key={idx}
                  label={btn.label}
                  startIcon={Icon ? <Icon /> : null}
                  onClick={() => {
                    if (btn.onClick === "openForm") {
                      openForm(schema, label);
                    } else if (typeof btn.onClick === "function") {
                      btn.onClick();
                    }
                  }}
                  sx={{ border: "none" }}
                />
              );
            })}
          </Box>
        )}
      </Box>
    );
  };

  const handleChange = () => {};

  const tableSchema = currentTab?.data
    ?.filter((item) => item.type === "table")
    ?.map((item) => item.schema);

  const handleSubUploadSuccess = (fileData) => {
    console.log("UPLOAD SUCCESS IN PARENT:", fileData);
    // ⭐ 3. Enable SAVE button
    // setIsRequiredFieldFilled(true);
  };

  const handleActions = async (payload) => {
    const { action, data } = payload;

    switch (action) {
      case "openDialog":
        openForm(data?.schema, "test");
        break;
      case "openSubDialog":
        const ComponentToRender = dynamicComponentMap[data.subComponent];
        if (!ComponentToRender) {
          console.warn(`⚠️ No component found for ${data.subComponent}`);
          return;
        }
        setSubDialogConfig({
          Component: ComponentToRender,
          props: {
            ...data.props,
            compKey: data.name,
            onUploadSuccess: handleSubUploadSuccess, // add this
          },
        });
        // setShowForm(false);
        setSubDialogOpen(true);

        break;

      case "delete":
        break;

      case "reset":
        break;

      case "refresh":
        handleRefresh(data?.api);
        break;

      case "navigate":
        navigate(data?.navigateTo);
        break;

      // DOWNLOAD
      case "downloadFile": {
        const file = formData?.documents?.fileId;

        if (!file || !file.filePath) {
          console.warn("No file available");
          return;
        }

        const url = `${import.meta.env.VITE_BASE_FILE_URL}${file.filePath}`;
        window.open(url, "_blank");
        break;
      }

      // REMOVE
      case "removeFile": {
        const file = formData?.documents?.fileId;

        if (!file?.exportNoteAttachmentId) return;

        await deleteFileAPI({ id: file.exportNoteAttachmentId });

        setFormData((prev) => ({
          ...prev,
          documents: {
            ...prev.documents,
            fileId: null,
          },
        }));

        alert("File removed");
        break;
      }

      // open file logic
      case "openFile": {
        const safePayload = {
          type,
          action,
          data,
          filename,
        };
        handleSubmit(safePayload);
        break;
      }
      case "deleteFormdata":
        const values = await formRef.current?.getCurrentValues();
        const drawbackid = values.deletedrawback;
        await handleDelete(drawbackid);

        break;

      default:
        console.warn("Unknown action:", action);
    }
  };

  const handleSubmit = ({ type, action, data, filename }) => {
    if (action === "openFile") {
      const targetFile =
        componentMap[currentActiveId] ||
        data?.filename?.trim() ||
        filename?.trim();

      if (componentMap[targetFile]) {
        setActiveFile(targetFile);
        setOpeningForm(false);
      } else {
        console.warn("❌ No component found for", targetFile);
      }
    }
  };

  const handleRefresh = async (api) => {
    if (!exporterCustomerid) return;
    try {
      setSaveLoading(true);
      const { fetch } = apiHooks[api] || {};
      if (!fetch) {
        console.warn(`No fetch method found for API: ${api}`);
        return;
      }
      const response = await fetch({ id: exporterCustomerid });
      setFormData((prev) => ({
        ...prev,
        [currentTab.id]: response,
      }));
    } catch (err) {
      console.error("Refresh error:", err);
    } finally {
      setSaveLoading(false);
    }
  };

  const initialSubTabs = useMemo(
    () =>
      activeItem.subTabs?.map((tab) => ({
        id: tab.id,
        label: tab.label,
        disabled: tab.disabled,
        hide: tab.hide,
      })) || [],
    [activeItem]
  );

  useEffect(() => {
    setSubTabs(initialSubTabs);
  }, [initialSubTabs]);

  const handleDynamicTabUpdate = (eximCode) => {
    setSubTabs((prevTabs) => updateTabsVisibilityGeneric(eximCode, prevTabs));
  };

  const updateTabsVisibilityGeneric = (eximCode, tabs) => {
    const visibleTabs = Object.keys(tabToEximCodeMap).filter((tabKey) =>
      tabToEximCodeMap[tabKey].includes(eximCode)
    );

    const visibleIds = visibleTabs.map((v) => v.toLowerCase());

    const updatedTabs = tabs.map((tab) => {
      const tabId = tab.id?.toLowerCase();

      const shouldBeVisible = visibleIds.includes(tabId);

      if (tab.hide === shouldBeVisible) {
        return { ...tab, hide: !shouldBeVisible };
      }
      return tab;
    });

    return updatedTabs;
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "8px",
        overflow: "hidden",
        height: "100vh",
        maxWidth: "100%",
      }}
    >
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="flex-start"
        flexWrap="wrap"
        flexShrink={0}
      >
        <Box
          sx={{
            display: "flex",
            flexShrink: 0,
            flexDirection: "column",
            gap: 0.5,
          }}
        >
          <Typography variant="heading">Create New Customer</Typography>

          <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
            {/* Export Dashboard */}
            <Typography
              variant="bodySmall"
              sx={{ color: "var(--link-blue)", cursor: "pointer" }}
              onClick={() => navigate(navurl.Organizations)}
            >
              Organization Dashboard
            </Typography>
            <Typography variant="bodySmall">/</Typography>
            {/* Current page */}
            <Typography variant="bodySmall" sx={{ color: "text.primary" }}>
              Create New Customer
            </Typography>
          </Box>
        </Box>

        <Box
          display="flex"
          flexWrap="wrap"
          alignItems="center"
          justifyContent="flex-end"
          gap={2}
          sx={{ flex: 1, flexWrap: "nowrap" }}
        >
          <BlackButton
            label="Add New Customer"
            variant="bodySmallMedium"
            startIcon={<LuPlus size={21} />}
            sx={{
              width: "200px",
              mt: 1,
              color: "var(--gray-0)",
              borderRadius: 2,
              textTransform: "none",
              backgroundColor: "var(--brand-600)",
            }}
            onClick={goToCreateNewJob}
          />
        </Box>
      </Box>

      {/* Render the   Filter Box  and  */}
      <Box
        sx={{
          flexShrink: 0,
          width: "100%",
          backgroundColor: "var(--gray-0)",
          borderRadius: 2,
          border: "1px solid var(--gray-100)",
        }}
      >
        <CreateFilterBox />
      </Box>

      <Box
        sx={{
          flexGrow: 1,
          minHeight: 0,
          backgroundColor: "var(--gray-0)",
          width: "100%",
          overflow: "auto",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <CreateJobLayout
          disabled={!customerId} // ✅
          activeIndex={activeIndex}
          setActiveIndex={(index) => {
            setActiveIndex(index);
          }}
          sx={{
            width: "100%",
            maxWidth: "90%",
            mx: "auto",
            flex: 1,
            display: "flex",
            flexDirection: "row",
          }}
        >
          <Box key={activeIndex} sx={{ width: "100%", mb: 2 }}>
            <Box>
              {activeItem?.type === "form" && (
                <Box sx={{ width: "100%", px: 2, py: 1 }}>
                  <FormGenerator
                    compKey={activeItem.id}
                    key={activeItem.id}
                    schema={activeItem.schema}
                    formName={activeItem.id} // 🔥🔥🔥 THIS FIXES EVERYTHING
                    onSubmit={handleActions}
                    ref={(refInstance) => {
                      if (
                        refInstance &&
                        typeof refInstance.setValue === "function"
                      ) {
                        formRef.current = refInstance; // ⭐⭐ THIS IS THE FIX ⭐⭐
                      }
                    }}
                    onRequiredFieldsChange={(allFilled) =>
                      setIsRequiredFieldFilled(allFilled)
                    } // ✅ pass this
                  />
                </Box>
              )}

              {activeItem?.type === "table" && (
                <Box>
                  {activeItem?.subButtons && (
                    <Box
                      display="flex"
                      justifyContent="flex-end"
                      width="100%"
                      flexWrap="wrap"
                      gap={1}
                      mb={2}
                    >
                      {activeItem?.subButtons?.map((btn, idx) => {
                        const Icon = iconMap[btn.icon];
                        return (
                          <OutLinedButton
                            key={idx}
                            label={btn.label}
                            startIcon={Icon ? <Icon /> : null}
                            onClick={() => {
                              if (btn.onClick === "openForm") {
                                openForm(activeItem.schema, activeItem.label);
                              } else if (typeof btn.onClick === "function") {
                                btn.onClick();
                              }
                            }}
                            sx={{
                              mr: 1,
                              mb: 1,
                              border: "none",
                              ...(btn.sx || {}),
                            }}
                          />
                        );
                      })}
                    </Box>
                  )}
                  <TableGenerator
                    handleSave={handleSave}
                    handleDelete={handleDelete}
                    label={activeItem.label}
                    ref={formRef}
                    compKey={activeItem.id}
                    key={activeItem.id}
                    handlers={handlers}
                    visibleFields={activeItem.visibleFields}
                    expandedFields={activeItem.expandedFields}
                    actions={activeItem?.actions || null}
                    loading={saveLoading}
                    onSubmit={handleActions}
                  />
                </Box>
              )}

              {activeItem?.type === "tableWithFields" && (
                <Box>
                  {/* For all table with field generator, pass the compkey, so that TableWithFieldGenerator will display the specific tab's initialvalue and pass the formRef, so that when submit the updated values will receive in the handleSave function*/}
                  <TableWithFieldGenerator
                    compKey={activeItem.id}
                    key={activeItem.id}
                    handleSave={handleSave}
                    handleDelete={handleDelete}
                    label={activeItem.label}
                    ref={formRef}
                    groupedHeaders={activeItem.groupedHeaders}
                    visibleFields={activeItem.visibleFields}
                    expandedFields={activeItem.expandedFields}
                    actions={activeItem?.actions}
                    tableSx={activeItem?.sx}
                  />
                </Box>
              )}

              {activeItem?.type === "formWithTable " && (
                <Box>
                  <FormGenerator
                    compKey={activeItem.id}
                    key={activeItem.id}
                    schema={activeItem.formSchema}
                    onSubmit={handleActions}
                    ref={formRef}
                    onRequiredFieldsChange={(allFilled) =>
                      setIsRequiredFieldFilled(allFilled)
                    } // ✅ pass this
                  />
                  <TableGenerator
                    compKey={activeItem.id}
                    key={activeItem.id}
                    handleSave={handleSave}
                    handleDelete={handleDelete}
                    label={activeItem.label}
                    ref={formRef}
                    handlers={handlers}
                    visibleFields={activeItem.visibleFields}
                    expandedFields={activeItem.expandedFields}
                    actions={activeItem?.actions || null}
                  />
                </Box>
              )}

              {activeItem.type === "component" &&
                activeItem.component &&
                (() => {
                  const Component = activeItem.component;
                  return (
                    <Component
                      {...activeItem.componentProps}
                      formData={formData}
                      setFormData={setFormData}
                      ref={formRef}
                      handleSave={handleSave}
                      handleDelete={handleDelete}
                      handleRowSelect={handleRowSelect}
                    />
                  );
                })()}

              {activeItem?.type === "tab" && (
                <Box>
                  {/* ⭐ 1. Render component above subTabs if hasComponent === true */}
                  {activeItem.hasComponent && activeItem.component && (
                    <activeItem.component
                      ref={formRef}
                      formData={formData}
                      setFormData={setFormData}
                      handleSave={handleSave}
                      handleDelete={handleDelete}
                      handleRowSelect={handleRowSelect}
                    />
                  )}
                  <CustomTabs
                    tabs={subTabs}
                    activeTab={activeSubIndex}
                    setActiveTab={setActiveSubIndex}
                    buttons={activeItem?.buttons || []}
                    onButtonClick={(button) => {
                      if (button.onClick === "openForm") {
                        // ✅ openForm is already defined in CreateNewJob
                        const schema =
                          activeSubTab?.schema || activeItem?.schema;
                        const label = button.label || activeItem?.label;
                        openForm(schema, label);
                      }
                    }}
                  />
                  {activeSubTab?.checkBox?.length > 0 && (
                    <Box display="flex" flexWrap="wrap" gap={1} px={3}>
                      {activeSubTab.checkBox.map((item, idx) => (
                        <CheckboxBox
                          key={idx}
                          checkboxLabel={item.label}
                          value={[item.label] || false}
                          onChange={(val) =>
                            handleCheckboxChange(item.label, val)
                          }
                        />
                      ))}
                    </Box>
                  )}

                  <Box>
                    {activeSubTab?.type === "form" && activeSubTab.schema && (
                      <>
                        <Box
                          mt={2}
                          px={4}
                          display="flex"
                          flexDirection="column"
                          gap={2}
                        >
                          {/* Form */}
                          <FormGenerator
                            compKey={activeSubTab.id}
                            formName={activeSubTab.id} // ⭐ ADD THIS
                            key={activeSubTab.id}
                            schema={activeSubTab.schema}
                            onSubmit={handleActions}
                            ref={formRef}
                            forceArray={activeSubTab.forceArray}
                            onRequiredFieldsChange={(allFilled) =>
                              setIsRequiredFieldFilled(allFilled)
                            }
                            onFieldValueChange={(value, fieldName) => {
                              handleDynamicTabUpdate(value); // your logic here
                            }}
                          />
                        </Box>
                      </>
                    )}
                    {/* Render current sub-tab's table */}
                    {activeSubTab?.type === "table" && (
                      <>
                        {(activeSubTab?.subcheckBox ||
                          activeSubTab?.subButtons) && (
                          <Box
                            display="flex"
                            alignItems="center"
                            justifyContent="space-between"
                            flexWrap="wrap"
                            gap={2}
                            mb={2}
                            ml={2} // optional left padding
                          >
                            {/* Left: Checkboxes */}
                            {activeSubTab?.subcheckBox?.length > 0 && (
                              <Box display="flex" flexWrap="wrap" gap={1}>
                                {activeSubTab.subcheckBox.map((item, idx) => (
                                  <CheckboxBox
                                    key={idx}
                                    checkboxLabel={item.label}
                                    value={[item.label] || false}
                                    onChange={(val) =>
                                      handleCheckboxChange(item.label, val)
                                    }
                                  />
                                ))}
                              </Box>
                            )}

                            {/* Right: SubButtons always flex-end */}
                            {activeSubTab?.subButtons?.length > 0 && (
                              <Box
                                display="flex"
                                flexWrap="wrap"
                                justifyContent="flex-end"
                                gap={1}
                                flexGrow={1}
                              >
                                {activeSubTab.subButtons.map((btn, idx) => {
                                  const Icon = iconMap[btn.icon];
                                  return (
                                    <OutLinedButton
                                      key={idx}
                                      label={btn.label}
                                      startIcon={Icon ? <Icon /> : null}
                                      onClick={() => {
                                        if (btn.onClick === "openForm") {
                                          openForm(
                                            activeSubTab.schema,
                                            activeSubTab.label
                                          );
                                        } else if (
                                          typeof btn.onClick === "function"
                                        ) {
                                          btn.onClick();
                                        }
                                      }}
                                      sx={{
                                        mr: 1,
                                        mb: 1,
                                        border: "none",
                                        ...(btn.sx || {}),
                                      }}
                                    />
                                  );
                                })}
                              </Box>
                            )}
                          </Box>
                        )}

                        <TableGenerator
                          compKey={activeSubTab.id}
                          key={activeSubTab.id}
                          handleSave={handleSave}
                          handleDelete={handleDelete}
                          visibleFields={activeSubTab.visibleFields}
                          expandedFields={activeSubTab.expandedFields}
                          label={activeSubTab.label}
                          ref={formRef}
                          handlers={handlers}
                          actions={activeSubTab?.actions || null}
                          onSubmit={handleActions} // ✅ VERY IMPORTANT
                        />
                      </>
                    )}

                    {activeSubTab?.type === "tableWithFields" && (
                      <TableWithFieldGenerator
                        compKey={activeSubTab.id}
                        key={activeSubTab.id}
                        handleSave={handleSave}
                        handleDelete={handleDelete}
                        label={activeSubTab.label}
                        ref={formRef}
                        groupedHeaders={activeSubTab.groupedHeaders}
                        visibleFields={activeSubTab.visibleFields}
                        expandedFields={activeSubTab.expandedFields}
                        actions={activeSubTab?.actions}
                        tableSx={activeSubTab?.sx}
                      />
                    )}
                    {activeSubTab?.type === "formWithTable" && (
                      <Box>
                        {activeSubTab?.checkBox?.length > 0 && (
                          <Box
                            display="flex"
                            flexWrap="wrap"
                            gap={1}
                            mb={2}
                            px={3}
                          ></Box>
                        )}

                        {activeSubTab.data?.map((section, idx) => {
                          if (section.type === "form") {
                            return (
                              <Box key={idx} mt={2} px={4}>
                                <FormGenerator
                                  compKey={activeSubTab.id + "Form"}
                                  key={activeSubTab.id + "Form"}
                                  schema={section.schema}
                                  onSubmit={handleActions}
                                  formName={activeItem.id} // 🔥🔥🔥 THIS FIXES EVERYTHING
                                  ref={formRef}
                                  onRequiredFieldsChange={(allFilled) =>
                                    setIsRequiredFieldFilled(allFilled)
                                  } // ✅ pass this
                                />
                              </Box>
                            );
                          }

                          if (section.type === "table") {
                            return (
                              <Box>
                                {renderButtons(
                                  section?.subButtons,
                                  section?.subcheckBox, // <-- pass checkboxes here
                                  section?.schema,
                                  section?.label,
                                  activeSubTab?.type === "formWithTable"
                                )}
                                <TableGenerator
                                  compKey={activeSubTab.id}
                                  key={activeSubTab.id}
                                  handleSave={handleSave}
                                  handleDelete={handleDelete}
                                  visibleFields={section.visibleFields}
                                  expandedFields={section.expandedFields}
                                  label={activeSubTab.label}
                                  ref={formRef}
                                  handlers={handlers}
                                  actions={section?.actions || null}
                                  onSubmit={handleActions}
                                />
                              </Box>
                            );
                          }

                          return null; // default
                        })}
                      </Box>
                    )}

                    {activeSubTab?.component &&
                      (() => {
                        const Component = activeSubTab.component;
                        return (
                          <Component
                            {...activeItem.componentProps}
                            formData={formData}
                            setFormData={setFormData}
                            ref={formRef}
                            handleSave={handleSave}
                            handleDelete={handleDelete}
                            handleRowSelect={handleRowSelect}
                            isDisabled={activeNestedIndex !== 0}
                          />
                        );
                      })()}

                    {activeSubTab?.type === "tab" && (
                      <>
                        <TabWithIndependentButtons
                          tabs={activeSubTab.subTabs}
                          buttons={(
                            activeSubTab.subTabs[activeNestedIndex]?.buttons ||
                            []
                          ).map((btn) => {
                            const Icon = iconMap[btn.icon];
                            return {
                              ...btn,
                              startAdornment: Icon ? <Icon /> : null,
                              sx: { border: "none", ...(btn.sx || {}) },
                              onClick: () => {
                                if (btn.onClick === "openForm") {
                                  const currentSub =
                                    activeSubTab.subTabs[activeNestedIndex];
                                  const currentId = currentSub?.id || null;

                                  setTableCompkey(currentId); // ✅ update state immediately

                                  openForm(
                                    currentSub.schema,
                                    currentSub.label,
                                    null, // ownerConfig
                                    null, // extraApi
                                    currentId // ✅ only send ID string, not the whole object
                                  );
                                }
                              },
                            };
                          })}
                          activeTab={activeNestedIndex}
                          setActiveTab={setActiveNestedIndex}
                        />

                        <Box mt={2}>
                          {(() => {
                            const nestedTab =
                              activeSubTab.subTabs[activeNestedIndex || 0];

                            if (
                              nestedTab?.type === "form" &&
                              nestedTab.schema
                            ) {
                              return (
                                <Box mt={2} px={4}>
                                  <FormGenerator
                                    compKey={nestedTab.id}
                                    key={nestedTab.id}
                                    schema={nestedTab.schema}
                                    formName={activeItem.id} // 🔥🔥🔥 THIS FIXES EVERYTHING
                                    onSubmit={handleActions}
                                    ref={formRef}
                                    onRequiredFieldsChange={(allFilled) =>
                                      setIsRequiredFieldFilled(allFilled)
                                    } // ✅ pass this
                                  />
                                </Box>
                              );
                            }

                            if (nestedTab?.type === "table") {
                              return (
                                <TableGenerator
                                  compKey={nestedTab.id}
                                  key={nestedTab.id}
                                  handleSave={handleSave}
                                  handlers={handlers}
                                  handleDelete={handleDelete}
                                  visibleFields={nestedTab.visibleFields}
                                  expandedFields={nestedTab.expandedFields}
                                  label={nestedTab.label}
                                  ref={formRef}
                                  actions={nestedTab?.actions || null}
                                />
                              );
                            }

                            return null;
                          })()}
                        </Box>
                      </>
                    )}
                  </Box>
                </Box>
              )}
            </Box>
          </Box>
        </CreateJobLayout>
      </Box>
      {/* </Box> */}
      <Box
        sx={{
          flexShrink: 0,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          position: "sticky",
          bottom: 0,
        }}
      >
        {/* Left Button: Declarations */}
        <OutLinedButton
          variant={"bodySmallStrong"}
          label="Declarations"
          sx={{
            width: "150px",
            height: "45px",

            textTransform: "none",
            border: "1px solid var(--brand-600)",
            borderRadius: "8px",
          }}
          width="180px"
          height="40px"
        />
        {/* Right Side Buttons */}
        <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
          <OutLinedButton
            variant={"bodySmallStrong"}
            label="Close"
            onClick={() => {
              // localStorage.removeItem("exporterCustomerid"); // ✅ clear when back is clicked
              localStorage.removeItem("filterData");
              navigate(navurl.Dashboard);
            }}
            sx={{
              fontSize: "13px",
              width: "120px",
              height: "40px",
              fontWeight: 600,
              textTransform: "none",
              border: "1px solid var(--brand-600)",
              borderRadius: "8px",
            }}
          />

          <BlackButton
            key={trigger}
            label={saveLoading ? "Saving..." : "Save"}
            sx={{
              width: "120px",
              height: "40px",
              fontSize: "13px",
              fontWeight: 500,
              textTransform: "none",
              boxShadow: "none",
              backgroundColor: "var(--brand-600)",
              color: "var(--gray-0)",
              border: "none",
              borderRadius: "8px",
              "&:hover": {
                backgroundColor: "var(--brand-600)",
                boxshadow: "none",
              },
              mb: 0,
            }}
            onClick={() => {
              !saveLoading && handleSave();
              setFilterTrigger(); // ⭐ FIRE FILTERBAR API
            }}
            disabled={
              !isRequiredFieldFilled || // FilterBar must be filled
              saveLoading ||
              currentTabType === "table"
            }
          />
        </Box>
      </Box>
      <SuccessDialog
        open={showSuccessDialog}
        onClose={() => {
          setShowSuccessDialog(false);
        }}
        {...successDialogConfig}
      />

      {showForm && (
        <FormDialog
          compKey={tablecompKey} // ✅ dynamic key from nested tab
          title={
            isEditing
              ? `Edit ${schema?.label ?? currentTab?.label}`
              : `Add ${schema?.label ?? currentTab?.label}`
          }
          schema={schema?.schema ?? currentTab?.schema ?? tableSchema[0]}
          initialData={formDialogData}
          isEditing={isEditing}
          onSubmit={() => handleSave("table")}
          handleActions={handleActions}
          onClose={handleCloseForm}
          showCancelButton={true}
          showSubmitButton={true}
          cancelLabel="Cancel"
          submitLabel={isEditing ? "Save" : "Add"}
          loading={loading}
          ref={formRef}
          disabled={!isRequiredFieldFilled}
        />
      )}

      {subDialogConfig && (
        <Dialog
          open={subDialogOpen}
          onClose={() => setSubDialogOpen(false)}
          fullWidth
          maxWidth="md"
        >
          <subDialogConfig.Component
            {...subDialogConfig.props}
            formRef={formRef} // ⭐ MUST PASS
            onUploadSuccess={handleSubUploadSuccess} // ⭐ MUST PASS
            onClose={() => setSubDialogOpen(false)}
            compKey={subDialogConfig?.props?.compKey}
          />
        </Dialog>
      )}
      {openComponent &&
        (() => {
          const DynamicComponent = dynamicComponentMap[openComponent.component];
          if (!DynamicComponent) return null;

          return (
            <DynamicComponent
              open={Boolean(anchorEl1)}
              anchorEl={anchorEl1}
              compKey={subDialogConfig?.props?.compKey}
              onClose={functionMap.handleClose}
              formRef={formRef} // ✅ CORRECT
              // ⭐⭐ ADD THIS ⭐⭐
              onUploadSuccess={handleSubUploadSuccess}
              {...openComponent.props}
            />
          );
        })()}
    </Box>
  );
};

export default React.memo(CreateNewJob);
